const days = require("dayjs");

exports.formatDate = (item, format) => {
    return days(item).format(format);
};

exports.formatDateString = (item, format) => {
    let passedDate = new Date(item)
    return days(passedDate).format(format);
};

exports.nowDate = (format) => {
    let item = days()
    return days(item).format(format);
};

exports.addDays = (item, amt, type) => {
    return days(item).add(amt, type).$d;
};